import { ViewUIModel } from '../models/view-ui.model';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { InteractTypeEnum } from '../models/interact-type.enum';
import { ViewWindow } from '../models/view-window.enum';
import { TutorialStateModel } from '../models/tutorial-state.model';
import { HelpTypeEnum } from '../models/help-type.enum';
import { ViewInputModeEnum } from '../models/view-input-mode.enum';
import { ViewLayoutConfig } from '../models/view-layout-config.enum';
import { WhiteboardAnnotateMode } from '../models/whiteboard-state.model';

export namespace ViewActions {
  export class SetCanHover {
    static readonly type = '[View] Set Can Hover';
    constructor(public canHover: boolean) { }
  }

  export class SetCanTouch {
    static readonly type = '[View] Set Can Touch';
    constructor(public canTouch: boolean) { }
  }

  export class SetCanFullscreen {
    static readonly type = '[View] Set Can Fullscreen';
    constructor(public canFullscreen: boolean) { }
  }

  export class SetUI {
    static readonly type = '[View] Set UI';
    constructor(public ui: ViewUIModel) { }
  }

  export class SetInitialUI {
    static readonly type = '[View] Set Initial UI';
    constructor(public ui: ViewUIModel) { }
  }

  export class SetInputEnabled {
    static readonly type = '[View] Set Input Enabled';
    constructor(public enabled: boolean) { }
  }

  export class SetSearchDisplayMode {
    static readonly type = '[View] Set Search Display Mode';
    constructor(public mode: TreeSearchDisplayMode) { }
  }

  export class TogglePresentation {
    static readonly type = '[View] Toggle Presentation';
    constructor(public active: boolean) { }
  }

  export class SetInteractType {
    static readonly type = '[View] Set Interact Type';
    constructor(public interactType: InteractTypeEnum) { }
  }

  export class SetOnDemand {
    static readonly type = '[View] Set On Demand';
    constructor(public onDemand: boolean) { }
  }

  export class SetLayout {
    static readonly type = '[View] Set Layout';
    constructor(public layout: ViewLayoutConfig) { }
  }
  export class ToggleHelpTab {
    static readonly type = '[View] Toggle Help Tab';
    constructor(public tab: HelpTypeEnum = HelpTypeEnum.Basics) { }
  }
  
  export class SetInputMode {
    static readonly type = '[View] Set Input Mode';
    constructor(public inputMode: ViewInputModeEnum) { }
  }
  
  export class SetTutorial {
    static readonly type = '[View] Set Tutorial';
    constructor(public tutorial: Partial<TutorialStateModel>) { }
  }

  export class StartTutorial {
    static readonly type = '[View] Start Tutorial';
    constructor(public intro: boolean) { }
  }

  export class TutorialSeen {
    static readonly type = '[View] Tutorial Seen';
    constructor(public seen: boolean) { }
  }

  export class TutorialNext {
    static readonly type = '[View] Tutorial Next';
    constructor() { }
  }

  export class TutorialPrevious {
    static readonly type = '[View] Tutorial Previous';
    constructor() { }
  }

  export class ToggleNodeInfo {
    static readonly type = '[View] Toggle Node Info';
    constructor(public show: boolean) { }
  }

  export class SetMultiPickModeEnabled {
    static readonly type = '[View] Set multi pick mode enabled';
    constructor(public enabled: boolean) { }
  }

  export class SetLabelBreakpoint {
    static readonly type = '[View] Set Label Breakpoint';
    constructor(public labelsBreakpoint: number) { }
  }

  export class SetUsePrintImage {
    static readonly type = '[View] Set Use Print Image';
    constructor(public usePrintImage: boolean) { }
  }

  export class SetWindows {
    static readonly type = '[View] Set Windows';
    constructor(public windows: ViewWindow[]) { }
  }

  export class OpenWindow {
    static readonly type = '[View] Open Window';
    constructor(public window: ViewWindow) { }
  }

  export class CloseWindow {
    static readonly type = '[View] Close Window';
    constructor(public window?: ViewWindow) { }
  }

  export class ToggleWindow {
    static readonly type = '[View] Toggle Window';
    constructor(public window: ViewWindow, public show: boolean) { }
  }

  export class ToggleMenu {
    static readonly type = '[View] Toggle Menu';
    constructor(public open: boolean) { }
  }

  export class SetWhiteboardEnabled {
    static readonly type = '[View] Whiteboard Enabled';
    constructor(public enabled: boolean) { }
  }

  export class SetWhiteboardBrushSize {
    static readonly type = '[View] Whiteboard Brush Size';
    constructor(public brushSize: number) { }
  }

  export class SetWhiteboardBrushColor {
    static readonly type = '[View] Whiteboard Brush Color';
    constructor(public brushColor: string) { }
  }

  export class SetWhiteboardTextSize {
    static readonly type = '[View] Whiteboard Text Size';
    constructor(public size: number) { }
  }

  export class SetWhiteboardEraserSize {
    static readonly type = '[View] Whiteboard Eraser Size';
    constructor(public eraserSize: number) { }
  }

  export class SetWhiteboardAnnotateMode {
    static readonly type = '[View] Whiteboard Annotate Mode';
    constructor(public mode: WhiteboardAnnotateMode) { }
  }

  export class SetWhiteboardHasPaint {
    static readonly type = '[View] Whiteboard Has Paint';
    constructor(public hasPaint: boolean) { }
  }

  export class SetWhiteboardHasText {
    static readonly type = '[View] Whiteboard Has Text';
    constructor(public hasText: boolean) { }
  }
}
